var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBcaIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4.5,
    r: 2.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7v8M12 9l-5 2M12 9l5 2M12 15l-3 6M12 15l3 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcaIcon);
export default __webpack_public_path__ + "static/media/BcaIcon.164b822bec4be519caa015ebe089b929.svg";
export { ForwardRef as ReactComponent };